import React from "react";
import { Box } from "@mui/material";
import TeamLeaderboard from "../../TeamLeaderboard";
import BarChart from "../../BarChart";
import BuyerPRList from "../../BuyerPRList";
import { FilterValues } from "../../FilterModal";
import styles from "./performanceDashboard.module.scss";

interface PerformanceDashboardProps {
  teamLeaderboard?: any[];
  pctComparisonByBuyers?: any[];
  prByBuyers?: any[];
  selectedYear?: string;
  teamLeaderboardSortBy?: string;
  onTeamLeaderboardSortChange?: (sortBy: string) => void;
  filters?: FilterValues;
}

const PerformanceDashboard: React.FC<PerformanceDashboardProps> = ({
  teamLeaderboard = [],
  pctComparisonByBuyers = [],
  prByBuyers = [],
  selectedYear,
  teamLeaderboardSortBy,
  onTeamLeaderboardSortChange,
  filters = {},
}) => {
  // Check if any date filters are applied
  const hasDateFilters = !!(filters.start_date || filters.end_date);

  return (
    <>
      <Box className={styles.fullWidthSection}>
        <TeamLeaderboard
          title="Team Leaderboard"
          data={teamLeaderboard}
          sortBy={teamLeaderboardSortBy}
          onSortChange={onTeamLeaderboardSortChange}
          showThisYear={!hasDateFilters}
        />
      </Box>

      <Box className={styles.chartsSection}>
        <BarChart
          title="PCT Comparison by Buyers"
          data={pctComparisonByBuyers}
          xAxisKey="buyer"
          bars={[{ dataKey: "days", color: "#5b6b9e", label: "Days" }]}
          height={320}
          showThisYear={!hasDateFilters}
          hideXAxisLabels={true}
          excelFileName="PCT_Comparison_by_Buyers"
        />
        <BuyerPRList
          title="PR by Buyers"
          data={prByBuyers}
          buyerKey="buyer"
          completedKey="completed"
          totalKey="total"
          showThisYear={!hasDateFilters}
        />
      </Box>
    </>
  );
};

export default PerformanceDashboard;
